import {useState, useEffect, useRef} from 'react';
import { Table, DatePicker, Select, Button, Modal, Form, Input, Tag, message } from 'antd';
import { getData, createData, updateData, deleteData } from '../api/api';
import {QRCodeCanvas} from "qrcode.react";
import jsPDF from "jspdf";
import bgImage from "../assets/img/QrPage.png";
import html2canvas from "html2canvas";
import {SearchOutlined} from "@ant-design/icons";
import { useTranslation } from 'react-i18next'; // Translation hook

const { Search } = Input;

const Terminals = ({isAdmin,isMerchant}) => {
    const { t } = useTranslation(); // Translation hook
    const [data, setData] = useState([]);
    const [merchants, setMerchants] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [mccCodes, setMccCodes] = useState([]);
    const [regions, setRegions] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
    const [isStatusModalVisible, setIsStatusModalVisible] = useState(false);
    const [isStaticQrModalVisible, setIStaticQrModalVisible] = useState(false);
    const [isUserModalVisible, setIsUserModalVisible] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [statusChangeRecord, setStatusChangeRecord] = useState(null);
    const [staticQrRecord, setStaticQrRecord] = useState(null);
    const [userTerminalRecord, setUserTerminalRecord] = useState(null);
    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();
    const [staticQrForm] = Form.useForm();
    const [userForm] = Form.useForm();
    const qrContainerRef = useRef(null);

    const downloadPDF = async (elementBox,filename) => {
        const pdf = new jsPDF('p', 'mm', 'a4');

        const img = new Image();
        img.src = bgImage;
        img.onload = async () => {
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            pdf.addImage(img, 'JPEG', 0, 0, pageWidth, pageHeight);

            if (elementBox) {
                qrContainerRef.current = elementBox;
                const canvas = await html2canvas(qrContainerRef.current);
                const imgData = canvas.toDataURL('image/png');
                const qrSize = 100.5;
                const xPos = (pageWidth - qrSize) / 2;
                const yPos = (pageHeight - qrSize) / 2.45;
                pdf.addImage(imgData, 'PNG', xPos, yPos, qrSize, qrSize);
            }

            pdf.save(filename+'.pdf');
        };
    };

    const columns = [
        {
            title: '№',
            key: 'index',
            width: 60,
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: 'ID', dataIndex: 'id', key: 'id', width: 150 },
        { title: t('terminals.name'), dataIndex: 'name', key: 'name', width: 150 },
        { title: t('terminals.terminalType'), dataIndex: 'terminalType', key: 'terminalType', width: 150 },
        { title: t('terminals.merchantName'), dataIndex: 'merchantName', key: 'merchantName', width: 150 },
        { title: t('terminals.bankAccountName'), dataIndex: 'bankAccountName', key: 'bankAccountName', width: 200 },
        {
            title: t('terminals.phones'),
            key: 'userPhones',
            width: 200,
            render: (_, record) => {
                if (!record.userPhones || record.userPhones.length === 0) {
                    return '-';
                }
                return record.userPhones.join('\n ');
            }
        },
        {
            title: t('terminals.downloadStaticQr'),
            dataIndex: 'staticQrLink',
            key: 'staticQrLink',
            width: 150,
            render: (link,record) => (
                link ?
                    <>
                        <Button
                            size="large"
                            type={"primary"}
                            onClick={async () => {
                                const element = document.getElementById(link);
                                if (!element) {
                                    console.error('QR kod elementi topilmadi!');
                                    return;
                                }
                                await downloadPDF(element,record.staticQrId);
                            }}
                        >
                            {record.staticQrId}
                        </Button>
                        <div
                            id={link}
                            style={{
                                display: 'flex',
                                position: 'absolute',
                                top: '-9999px',
                                left: '-9999px',
                                transform: 'translate(-50%, -50%)',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '310px',
                                height: '310px',
                            }}
                        >
                            <QRCodeCanvas value={link} size={280} />
                        </div>

                        {isAdmin ? <Button
                            style={{backgroundColor:'red', color:'white',marginTop:'10px'}}
                            onClick={() => statikQrModal(record)}
                        >
                            {t('terminals.changeStaticQr')}
                        </Button>:''}

                    </> : isAdmin ? <Button
                        type={"dashed"}
                        onClick={() => statikQrModal(record)}
                    >
                        {t('terminals.attachStaticQr')}
                    </Button> : <p>{t('terminals.staticQrNotAttached')}</p>

            ),
        },
        { title: t('terminals.mccCode'), dataIndex: 'mccCode', key: 'mccCode', width: 200 },
        { title: t('terminals.createdAt'), dataIndex: 'createdAt', key: 'createdAt', width: 180 },
        { title: t('terminals.updatedAt'), dataIndex: 'updatedAt', key: 'updatedAt', width: 180 },
        { title: "Region", dataIndex: 'regionName', key: 'regionName', width: 200 },
        { title: "District", dataIndex: 'districtName', key: 'districtName', width: 200 },
        { title: "latitude", dataIndex: 'latitude', key: 'latitude', width: 150 },
        { title: "longitude", dataIndex: 'longitude', key: 'longitude', width: 150 },
        { title: "Address", dataIndex: 'address', key: 'address', width: 300 },
        {
            title: t('terminals.status'),
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) =>
                status === 0 ? (
                    <Tag color="green">{t('terminals.active')}</Tag>
                ) : (
                    <Tag color="red">{t('terminals.inactive')}</Tag>
                ),
        }
    ];

    if (isAdmin || isMerchant){
        columns.push({
            title: t('terminals.actions'),
            key: 'actions',
            width: 600,
            render: (_, record) => (
                <>
                    <Button size="small" type="primary" onClick={() => showUserModal(record)}>
                        {t('terminals.addUser')}
                    </Button>
                    {
                        isAdmin ? <>
                            <Button size="small" onClick={() => handleUpdateModal(record)} style={{ marginLeft: 8 }}>
                                {t('terminals.edit')}
                            </Button>
                            <Button
                                size="small"
                                danger={record.status === 0}
                                type={record.status === 0 ? "primary" : "default"}
                                onClick={() => showStatusChangeModal(record)}
                                style={{ marginLeft: 8 }}
                            >
                                {record.status === 0 ? t('terminals.deactivate') : t('terminals.activate')}
                            </Button>
                        </> : ''
                    }
                </>
            ),
        })
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData(isAdmin ? '/admin/dashboard/terminal-list-by-filter'
                : isMerchant  ?'/merchant/dashboard/terminal-list-by-filter' : '/merchant-user/dashboard/terminal-list-by-filter', {
                page: pagination.current - 1,
                size: pagination.pageSize,
                status: -1,
                ...filters,
            });
            setData(response.data?.data?.content || []);
            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
            message.error(t('terminals.dataLoadError'));
        }
        setLoading(false);
    };

    const getMerchants = async () => {
        try {
            const response = await getData('/admin/dashboard/merchants-list-by-filter', {
                page: 0,
                size: 1000000,
                status: -1,
            });
            setMerchants(response.data?.data?.content || []);
        } catch (error) {
            console.error(error);
            message.error(t('terminals.merchantsLoadError'));
        }
    };

    const getRegions = async () => {
        try {
            const response = await getData('/admin/dashboard/region/list', null);
            console.log(response)
            setRegions(response.data?.data || []);
        } catch (error) {
            console.error(error);
            message.error(t('terminals.merchantsLoadError'));
        }
    };

    const getDistricts = async () => {
        const rId =  form.getFieldValue('regionId') || (currentRecord?.regionId) || filters.regionId;
      if (rId){
          try {
              const response = await getData('/admin/dashboard/district/list/by-region-id', {
                  regionId:rId
              });
              setDistricts(response.data?.data || []);
          } catch (error) {
              console.error(error);
              message.error(t('terminals.merchantsLoadError'));
          }
      }
    };

    const getBankAccounts = async () => {
        const mId = filters.merchantId || form.getFieldValue('merchantId') || (currentRecord?.merchantId);
        if (!isAdmin || mId) {
            try {
                const response = await getData(isAdmin ? '/admin/dashboard/bank-account-list-by-filter' :
                    '/merchant/dashboard/bank-account-list-by-filter', {
                    page: 0,
                    size: 10000000,
                    status: -1,
                    merchantId: mId,
                });
                setBankAccounts(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
                message.error(t('terminals.bankAccountsLoadError'));
            }
        } else {
            setBankAccounts([]);
        }
    };

    const getMccCodes = async () => {
        if (mccCodes.length===0){
            try {
                const response = await getData('/admin/mcc/list', {
                });
                setMccCodes(response.data?.data || []);
            } catch (error) {
                console.error(error);
                message.error(t('terminals.mccCodesLoadError'));
            }
        }
    };

    useEffect(() => {
        fetchData();
        if (isAdmin && merchants?.length===0) {
            getMerchants();
        }

        if (isAdmin && regions?.length===0) {
            getRegions();
        }
    }, [pagination.current, pagination.pageSize, filters]);

    useEffect(() => {
        if (isAdmin || isMerchant){
            getBankAccounts();
        }
        getDistricts()
    }, [filters.merchantId, filters.regionId]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 });
    };

    const handleCreate = async (values) => {
        try {
            const response = await createData(
                '/admin/terminal/create',
                values
            );
            if (response?.data?.success && response?.data?.data){
                message.success(t('terminals.successAdd'));
                fetchData();
                handleCancel();
            }else {
                alert(response?.data?.error?.text || t('terminals.errorAdd'))
            }
        } catch (error) {
            console.error(error);
            alert(t('terminals.errorAdd'))
            message.error(t('terminals.errorAdd'));
        }
    };

    const handleUpdateModal = (record) => {
        setCurrentRecord(record);
        updateForm.setFieldsValue({
            name: record.name,
            mccCode: record.mccCode,
            districtId: record.districtId,
            latitude: record.latitude,
            longitude: record.longitude,
            address: record.address
        });
        setIsUpdateModalVisible(true);
        getMccCodes();
    };

    const handleUpdate = async (values) => {
        try {
            const response = await createData('/admin/terminal/update',{
                ...values,
                id: currentRecord.id
            });
            if (response?.data?.success && response?.data?.data){
                message.success(t('terminals.successUpdate'));
                fetchData();
                handleUpdateCancel()
            }else {
                alert(response?.data?.error?.text || t('terminals.updateError'));
            }

        } catch (error) {
            console.error(error);
            alert(t('terminals.updateError'))
            message.error(t('terminals.updateError'));
        }
    };

    const handleStaticQrUpdate = async (values) => {
        try {
            const response = await createData('/admin/static-qr/update',{
                ...values,
                terminalId: staticQrRecord.id
            });
            if (response?.data?.success && response?.data?.data){
                message.success(t('terminals.staticQrSuccessUpdate'));
                fetchData();
                statikQrCancel();
            }else {
                alert(response?.data?.error?.text || t('terminals.staticQrUpdateError'));
            }

        } catch (error) {
            console.error(error);
            alert(t('terminals.staticQrUpdateError'))
            message.error(t('terminals.staticQrUpdateError'));
        }
    };

    const showUserModal = (record) => {
        setUserTerminalRecord(record);
        userForm.resetFields();
        setIsUserModalVisible(true);
    };

    const handleUserCancel = () => {
        setIsUserModalVisible(false);
        userForm.resetFields();
        setUserTerminalRecord(null);
    };

    const handleAddUser = async (values) => {
        try {
            const apiURL = isAdmin
                ? '/admin/terminal/add-terminal-user'
                : '/merchant/terminal/add-terminal-user';

            const payload = {
                phone: values.phone,
                fullname: values.fullname,
                terminalId: userTerminalRecord.id
            };

            const response = await createData(apiURL, payload);

            if (response?.data?.success && response?.data?.data) {
                message.success(t('terminals.userSuccessAdd'));
                fetchData();
                handleUserCancel();
            } else {
                alert(response?.data?.error?.text || t('terminals.userAddError'));
            }
        } catch (error) {
            console.error(error);
            alert(t('terminals.userAddError'));
            message.error(t('terminals.userAddError'));
        }
    };

    const showStatusChangeModal = (record) => {
        setStatusChangeRecord(record);
        setIsStatusModalVisible(true);
    };

    const handleStatusChangeCancel = () => {
        setIsStatusModalVisible(false);
        setStatusChangeRecord(null);
    };

    const statikQrModal = (record) => {
        setStaticQrRecord(record);
        setIStaticQrModalVisible(true);
    };

    const statikQrCancel = () => {
        setIStaticQrModalVisible(false);
        setStaticQrRecord(null);
    };

    const handleChangeStatus = async () => {
        try {
            const newStatus = statusChangeRecord.status === 0 ? 1 : 0;
            const response = await createData('/admin/terminal/update',{
                ...statusChangeRecord,
                status:newStatus
            });
            if (response?.data?.success && response?.data?.data){
                message.success(t('terminals.successUpdate'));
                fetchData();
                handleStatusChangeCancel();
            }else {
                alert(response?.data?.error?.text || t('terminals.updateError'));
            }

        } catch (error) {
            console.error(error);
            alert(t('terminals.updateError'))
            message.error(t('terminals.updateError'));
        }
    };

    const showModal = () => {
        setIsModalVisible(true);
        form.resetFields();
        form.setFieldsValue({ terminalType: 'WEB_TERMINAL' });
        getMccCodes();
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const handleUpdateCancel = () => {
        setIsUpdateModalVisible(false);
        updateForm.resetFields();
        setCurrentRecord(null);
    };

    const handleMerchantChange = (value) => {
        form.setFieldValue('bankAccountId', undefined);
        form.setFieldValue('merchantId', value);
        getBankAccounts();
    };

    const handleRegionChange = (value) => {
        form.setFieldValue('districtId', undefined);
        form.setFieldValue('regionId', value);
        getDistricts();
    };
    const handleUpdateMerchantChange = (value) => {
        updateForm.setFieldValue('bankAccountId', undefined);
        updateForm.setFieldValue('merchantId', value);
        getBankAccounts();
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>{t('terminals.title')}</h2>
                {isAdmin ?
                    <Button type="primary" onClick={showModal}>
                        {t('terminals.add')}
                    </Button> :''}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                {isAdmin ?
                    <Select
                        style={{ width: 200 }}
                        defaultValue={null}
                        onChange={(value) => handleFilter({ ...filters, merchantId: value })}
                        size="middle"
                        placeholder={t('terminals.selectMerchant')}
                        showSearch
                        filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                        allowClear
                        notFoundContent={t('terminals.notFound')}
                        dropdownStyle={{ zIndex: 9999 }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                    >
                        {merchants?.map((value) => (
                            <Select.Option key={value.id} value={value.id}>
                                {value.name}
                            </Select.Option>
                        ))}
                    </Select>:''}
                {
                    isAdmin || isMerchant ?
                        <Select
                            style={{ width: 200 }}
                            defaultValue={null}
                            onChange={(value) => handleFilter({ ...filters, bankAccountId: value })}
                            size="middle"
                            placeholder={t('terminals.selectBankAccount')}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={t('terminals.notFound')}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            disabled={isAdmin ? !filters.merchantId : false}
                        >
                            {bankAccounts?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.name}
                                </Select.Option>
                            ))}
                        </Select>:' '
                }

                {
                    isAdmin ?
                        <Select
                            style={{ width: 200 }}
                            defaultValue={null}
                            onChange={(value) => handleFilter({ ...filters, regionId: value })}
                            size="middle"
                            placeholder={"Regions"}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={"Not found"}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {regions?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.nameRu}
                                </Select.Option>
                            ))}
                        </Select>:' '

                }

                {
                    isAdmin ?
                        <Select
                            style={{ width: 200 }}
                            defaultValue={null}
                            onChange={(value) => handleFilter({ ...filters, districtId: value })}
                            size="middle"
                            placeholder={"Districts"}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={"Not found"}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            disabled={!filters.regionId}
                        >
                            {districts?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.nameRu}
                                </Select.Option>
                            ))}
                        </Select>:' '

                }

                <Search
                    placeholder={t('terminals.searchPlaceholder')}
                    allowClear
                    enterButton={<SearchOutlined />}
                    size="middle"
                    style={{ width: 300 }}
                    onSearch={(value) => handleFilter({ ...filters, search: value })}
                />
            </div>

            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => t('terminals.total', { total }),
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }}
            />

            {/* Terminal qo'shish modali */}
            <Modal
                title={t('terminals.addTitle')}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        name="name"
                        label={t('terminals.terminalName')}
                        rules={[{ required: true, message: t('terminals.nameRequired') }]}
                    >
                        <Input placeholder={t('terminals.terminalNamePlaceholder')} />
                    </Form.Item>

                    <Form.Item
                        name="terminalType"
                        label={t('terminals.terminalType')}
                        rules={[{ required: true, message: t('terminals.terminalTypeRequired') }]}
                    >
                        <Select
                            placeholder={t('terminals.terminalType')}
                            showSearch
                            allowClear
                            notFoundContent={t('terminals.notFound')}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            <Select.Option key={'WEB_TERMINAL'} value={'WEB_TERMINAL'}>
                                WEB_TERMINAL
                            </Select.Option>
                            <Select.Option key={'POS_TERMINAL'} value={'POS_TERMINAL'}>
                                POS_TERMINAL
                            </Select.Option>

                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="merchantId"
                        label={t('merchants.title')}
                        rules={[{ required: true, message: t('terminals.merchantRequired') }]}
                    >
                        <Select
                            placeholder={t('terminals.selectMerchant')}
                            onChange={handleMerchantChange}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={t('terminals.notFound')}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {merchants?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="bankAccountId"
                        label={t('bankAccounts.title')}
                        rules={[{ required: true, message: t('terminals.bankAccountRequired') }]}
                        dependencies={['merchantId']}
                    >
                        <Select
                            placeholder={t('terminals.selectBankAccount')}
                            disabled={!form.getFieldValue('merchantId')}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={t('terminals.notFound')}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {bankAccounts?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="mccCode"
                        label={t('terminals.mccCode')}
                        rules={[{ required: true, message: t('terminals.mccCodeRequired') }]}
                    >
                        <Select
                            placeholder={t('terminals.selectMccCode')}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.join('').toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {mccCodes?.map((value) => (
                                <Select.Option key={value.code} value={value.code}>
                                    {value.code} - {value.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="regionId"
                        label={"Regions"}
                    >
                        <Select
                            placeholder={"Select regions"}
                            onChange={handleRegionChange}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={"Not found"}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {regions?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.nameRu}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="districtId"
                        label={"Districts"}
                        dependencies={['regionId']}
                    >
                        <Select
                            placeholder={"Select districts"}
                            disabled={!form.getFieldValue('regionId')}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={"Not found"}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {districts?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.nameRu}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="latitude"
                        label={"Latitude"}
                    >
                        <Input placeholder={"41.303864"} />
                    </Form.Item>

                    <Form.Item
                        name="longitude"
                        label={"Longitude"}
                    >
                        <Input placeholder={"69.289017"} />
                    </Form.Item>

                    <Form.Item
                        name="address"
                        label={t('terminals.address')}
                    >
                        <Input placeholder={t('terminals.addressPlaceholder')} />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                        <Button style={{ marginRight: 8 }} onClick={handleCancel}>
                            {t('terminals.cancel')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {t('terminals.add')}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Terminal o'zgartirish modali */}
            <Modal
                title={t('terminals.updateTitle')}
                visible={isUpdateModalVisible}
                onCancel={handleUpdateCancel}
                footer={null}
            >
                <Form form={updateForm} onFinish={handleUpdate} layout="vertical">
                    <Form.Item
                        name="name"
                        label={t('terminals.terminalName')}
                        rules={[{ required: true, message: t('terminals.nameRequired') }]}
                    >
                        <Input placeholder={t('terminals.terminalNamePlaceholder')} />
                    </Form.Item>

                    <Form.Item
                        name="mccCode"
                        label={t('terminals.mccCode')}
                        rules={[{ required: true, message: t('terminals.mccCodeRequired') }]}
                    >
                        <Select
                            placeholder={t('terminals.selectMccCode')}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.join('').toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {mccCodes?.map((value) => (
                                <Select.Option key={value.code} value={value.code}>
                                    {value.code} - {value.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="regionId"
                        label={"Regions"}
                    >
                        <Select
                            placeholder={"Select regions"}
                            onChange={handleRegionChange}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={"Not found"}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {regions?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.nameRu}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="districtId"
                        label={"Districts"}
                        dependencies={['regionId']}
                    >
                        <Select
                            placeholder={"Select districts"}
                            disabled={!form.getFieldValue('regionId')}
                            showSearch
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                            notFoundContent={"Not found"}
                            dropdownStyle={{ zIndex: 9999 }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                        >
                            {districts?.map((value) => (
                                <Select.Option key={value.id} value={value.id}>
                                    {value.nameRu}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="latitude"
                        label={"Latitude"}
                    >
                        <Input placeholder={"41.303864"} />
                    </Form.Item>

                    <Form.Item
                        name="longitude"
                        label={"Longitude"}
                    >
                        <Input placeholder={"69.289017"} />
                    </Form.Item>

                    <Form.Item
                        name="address"
                        label={t('terminals.address')}
                    >
                        <Input placeholder={t('terminals.addressPlaceholder')} />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                        <Button style={{ marginRight: 8 }} onClick={handleUpdateCancel}>
                            {t('terminals.cancel')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {t('terminals.save')}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Holat o'zgartirish tasdiq modali */}
            <Modal
                title={t('terminals.statusTitle')}
                visible={isStatusModalVisible}
                onCancel={handleStatusChangeCancel}
                footer={[
                    <Button key="cancel" onClick={handleStatusChangeCancel}>
                        {t('terminals.cancel')}
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleChangeStatus}>
                        {t('terminals.confirm')}
                    </Button>
                ]}
            >
                <p>
                    {t('terminals.statusQuestion', {
                        name: statusChangeRecord?.name,
                        status: statusChangeRecord?.status === 0 ? t('terminals.inactive') : t('terminals.active')
                    })}
                </p>
            </Modal>

            {/*Static qr biriktirsh uchun modal */}
            <Modal
                title={t('terminals.attachStaticQr')}
                visible={isStaticQrModalVisible}
                onCancel={statikQrCancel}
                footer={null}
            >
                <Form form={staticQrForm} onFinish={handleStaticQrUpdate} layout="vertical">
                    <Form.Item
                        name="id"
                        label={t('terminals.staticQrId')}
                        rules={[{ required: true, message: t('terminals.staticQrIdRequired') }]}
                    >
                        <Input placeholder="202505112322...." />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                        <Button style={{ marginRight: 8 }} onClick={statikQrCancel}>
                            {t('terminals.cancel')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {t('terminals.save')}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* Foydalanuvchi qo'shish modali */}
            <Modal
                title={t('terminals.addUserTitle')}
                visible={isUserModalVisible}
                onCancel={handleUserCancel}
                footer={null}
            >
                <Form form={userForm} onFinish={handleAddUser} layout="vertical">
                    <Form.Item
                        name="phone"
                        label={t('terminals.phone')}
                        rules={[
                            { required: true, message: t('terminals.phoneRequired') },
                            { pattern: /^[0-9+]+$/, message: t('terminals.phonePattern') }
                        ]}
                    >
                        <Input placeholder={t('terminals.phonePlaceholder')} />
                    </Form.Item>

                    <Form.Item
                        name="fullname"
                        label={t('terminals.fullName')}
                    >
                        <Input placeholder={t('terminals.fullNamePlaceholder')} />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                        <Button style={{ marginRight: 8 }} onClick={handleUserCancel}>
                            {t('terminals.cancel')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {t('terminals.add')}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Terminals;